import styled from 'styled-components';
import { em } from 'polished';

import { lessThan, greaterThan } from '../../../utils/mediaQuery';
import theme from '../../../styles/theme';
import breakpoints from '../../../styles/breakpoints';
import responsiveStyle from '../../../utils/responsiveStyle';

import Button, { buttonStyles } from '../../Button';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;

  z-index: 2;

  width: 100vw;

  background-color: ${theme.colors.mineShaft400};
`;

export const Content = styled.div`
  box-sizing: content-box;
  max-width: ${(props) => (props.larger ? '1920px' : '1356px')};
  margin: 0 auto;

  padding: ${em(24)};

  ${greaterThan(theme.breakpoints.fonts[0])} {
    padding: ${em(24)};
  }
`;

export const Layout = styled.div`
  display: grid;
  grid-row-gap: ${em(32)};
  grid-column-gap: ${em(20)};
  grid-template-areas: 'previous next' 'stepper stepper';
  align-items: center;
  justify-content: space-between;

  ${greaterThan(theme.breakpoints[3])} {
    grid-gap: ${em(46)};
    grid-template-areas: 'previous stepper next';
    grid-template-columns: auto 1fr auto;
  }
`;

export const NavigationButton = styled(Button)`
  &&& {
    ${responsiveStyle('minWidth', [128, 270], breakpoints.fonts)};
  }

  ${lessThan(theme.breakpoints.fonts[0])} {
    && > span {
      margin: 0;
    }
  }

  border-radius: 50px;

  ${buttonStyles.biggerStyle}
`;

export const PreviousButton = styled(NavigationButton)`
  grid-area: previous;

  && {
    color: ${theme.colors.brownGrey};

    border-color: ${theme.colors.brownGrey};

    &:focus,
    &:hover:not(:disabled) {
      color: ${theme.colors.mineShaft};

      background-color: ${theme.colors.brownGrey};
    }

    &:disabled {
      opacity: 0.4;
    }
  }
`;

export const NextButton = styled(NavigationButton)`
  grid-area: next;
`;
